module.exports = __webpack_public_path__ + "img/1701389112876-c9cece62-3893-4cfd-8257-5beb6ae9fc29.jpeg.643c3567.webp";